import React, { useState } from "react";
import api from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [devLink, setDevLink] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setDevLink("");
    try {
      const payload = {};
      if (email) payload.email = email;
      if (username) payload.username = username;
      if (!payload.email && !payload.username) {
        setMessage("Ingresa correo o usuario");
        setLoading(false);
        return;
      }
      const { data } = await api.post("user/password-reset/request/", payload);
      setMessage("Si el correo/usuario existe, te enviamos las instrucciones.");
      if (data?.devLink) setDevLink(data.devLink);
    } catch (err) {
      setMessage("Si el correo/usuario existe, te enviamos las instrucciones.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 p-6 w-full max-w-md">
        <h1 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">Recuperar acceso</h1>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">Ingresa tu correo o tu usuario y te enviaremos un enlace para restablecer tu contraseña.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">Correo (opcional)</label>
            <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white" placeholder="tucorreo@ejemplo.com" />
          </div>
          <div>
            <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">Usuario (opcional)</label>
            <input value={username} onChange={(e)=>setUsername(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white" placeholder="tu usuario" />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg py-2 font-medium disabled:opacity-60">
            {loading? 'Enviando…' : 'Enviar instrucciones'}
          </button>
        </form>
        {message && <div className="mt-4 text-sm text-gray-700 dark:text-gray-200">{message}</div>}
        {devLink && (
          <div className="mt-3 text-xs text-gray-600 dark:text-gray-300 break-all">
            Enlace de prueba (dev): <a href={devLink} className="text-indigo-600" target="_blank" rel="noreferrer">{devLink}</a>
          </div>
        )}
      </div>
    </div>
  );
}
